import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi } from "@/lib/api";
import { Input } from "@/components/ui/input";

/** Admin: barcodes scanned on the public site — map unmatched UPCs to a set by hand. */
export function Barcodes() {
  const [data, setData] = useState({ rows: [], unmatched: 0 });
  const [onlyUnmatched, setOnlyUnmatched] = useState(true);
  const [draft, setDraft] = useState({});
  const load = () => adminApi.barcodes(onlyUnmatched).then(setData).catch(() => toast.error("Failed to load barcodes"));
  useEffect(() => { load(); }, [onlyUnmatched]); // eslint-disable-line react-hooks/exhaustive-deps
  const save = async (code) => {
    try { await adminApi.mapBarcode(code, draft[code] || ""); toast.success(draft[code] ? `Mapped ${code} → ${draft[code]}` : "Mapping cleared"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
  };
  const del = async (code) => { try { await adminApi.deleteBarcode(code); load(); } catch { toast.error("Delete failed"); } };
  return (
    <div className="space-y-3" data-testid="o4b-barcodes">
      <div className="flex items-center gap-3 font-mono text-xs">
        <button onClick={() => setOnlyUnmatched(true)} data-testid="o4b-barcodes-unmatched" className={`h-8 px-3 border rounded-sm ${onlyUnmatched ? "border-[#E3000B] text-[#E3000B]" : "border-[#E4E4E0] text-gray-600"}`}>UNMATCHED ({data.unmatched})</button>
        <button onClick={() => setOnlyUnmatched(false)} data-testid="o4b-barcodes-all" className={`h-8 px-3 border rounded-sm ${!onlyUnmatched ? "border-[#E3000B] text-[#E3000B]" : "border-[#E4E4E0] text-gray-600"}`}>ALL</button>
        <span className="text-gray-500">Customers' camera scans · type the set number to map a barcode we couldn't recognise</span>
      </div>
      <div className="border border-[#E4E4E0] rounded-sm overflow-x-auto">
        <table className="w-full text-xs font-mono">
          <thead className="bg-[#F6F6F3] text-gray-500 uppercase text-[10px]"><tr>
            <th className="px-3 py-2 text-left">Barcode</th><th className="px-3 py-2 text-left">Title we saw</th><th className="px-3 py-2 text-left">Set</th><th className="px-3 py-2 text-left">Source</th><th className="px-3 py-2 text-right">Scans</th><th className="px-3 py-2 text-left">Last scan</th><th />
          </tr></thead>
          <tbody>
            {data.rows.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-gray-500">{onlyUnmatched ? "No unmatched barcodes — every scan resolved." : "No barcodes scanned yet."}</td></tr>}
            {data.rows.map(r => (
              <tr key={r.code} className="border-t border-[#F6F6F3]" data-testid={`o4b-barcode-${r.code}`}>
                <td className="px-3 py-2 text-gray-900">{r.code}</td>
                <td className="px-3 py-2 text-gray-600 max-w-[320px] truncate" title={r.title || ""}>{r.title || "—"}</td>
                <td className="px-3 py-2">
                  <div className="flex items-center gap-1">
                    <Input value={draft[r.code] ?? (r.set_number || "")} onChange={(e) => setDraft(d => ({ ...d, [r.code]: e.target.value }))} placeholder="e.g. 75192"
                      className="h-7 w-28 bg-[#F6F6F3] border-[#E4E4E0] text-xs" data-testid={`o4b-barcode-input-${r.code}`} />
                    <button onClick={() => save(r.code)} data-testid={`o4b-barcode-save-${r.code}`} className="h-7 px-2 border border-[#E4E4E0] rounded-sm hover:border-[#00A850] hover:text-[#00A850]">SAVE</button>
                  </div>
                </td>
                <td className={`px-3 py-2 ${r.set_number ? "text-[#00A850]" : "text-[#FF3B30]"}`}>{r.set_number ? (r.source || "manual") : "unmatched"}</td>
                <td className="px-3 py-2 text-right text-gray-600">{r.scans || 0}</td>
                <td className="px-3 py-2 text-gray-500 whitespace-nowrap">{r.last_scanned_at ? new Date(r.last_scanned_at).toLocaleString() : "—"}</td>
                <td className="px-3 py-2 text-right"><button onClick={() => del(r.code)} data-testid={`o4b-barcode-delete-${r.code}`} className="text-gray-400 hover:text-[#FF3B30]">✕</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
